import {CommonModule} from '@angular/common';
import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormsModule} from "@angular/forms";

import {BaseComponent} from "@wms/components";
import {isFileSizeWithinLimit, isZipFile} from "@wms/core";

type _model = {
  type: string;
  value: string | null;
  choosenFiles: FileList | null;
  msg: string;
};

@Component({
  standalone: true,
  selector: 'wms-file-upload',
  templateUrl: './wms-file-upload.component.html',
  imports: [
    CommonModule,
    FormsModule
  ],
  styleUrls: ['./wms-file-upload.component.less']
})
export class WMSFileUploadComponent extends BaseComponent implements OnInit{
  model!: _model | undefined;
  @Input() acceptType!: string;
  @Input() disabled!: boolean;
  @Output() onChoose!: EventEmitter<_model>;
  @Output() onClick!: EventEmitter<Event>;
  @Input() acceptMultipleFiles!: boolean;
  @ViewChild("uploadFiles") uploadFilesInputEl!: ElementRef;

  onUploadFilesClick($event: Event): void {
    this.onClick.emit($event);
  }
  validateResource(): void {
    let uploadFiles: FileList = this.uploadFilesInputEl.nativeElement.files;
    let MAX_FILE_SIZE: number = 50;
    if (uploadFiles.length > 0) {
      for (let uploadFile of Array.from(uploadFiles)) {
        if (!isFileSizeWithinLimit(uploadFile, MAX_FILE_SIZE)) {
          this.model = {
            type: "ERROR",
            value: null,
            choosenFiles: null,
            msg: this.locale.LABEL_PROPERTY_MAXFILESIZE_EXCEEDED
          }
          this.onChoose.emit(this.model);
          return;
        }
        if (this.acceptType === ".zip" && !isZipFile(uploadFile.name)) {
          this.model = {
            type: 'ERROR',
            value: null,
            choosenFiles: null,
            msg: this.locale.MESSAGE_ERROR_ZIP_INVALID_FILE
          };
          this.onChoose.emit(this.model);
          return;
        }
      }
      this.model = {
        type: 'SUCCESS',
        value: this.getModelValue(uploadFiles),
        choosenFiles: uploadFiles,
        msg: ''
      };
      this.onChoose.emit(this.model);
      return;
    }
  }
  getModelValue(uploadFiles: FileList): string | null {
    let modelValue = null;
    for (let uploadFile of Array.from(uploadFiles)) {
      if (modelValue === null) {
        modelValue = uploadFile.name;
      } else {
        modelValue = modelValue + ", " + uploadFile.name;
      }
    }
    return modelValue;
  }
  resetModel(): void {
    this.model = undefined;
    this.uploadFilesInputEl.nativeElement.value = null;
  }
  constructor() {
    super();
    this.onChoose = new EventEmitter<_model>();
    this.onClick = new EventEmitter<Event>();
  }
  ngOnInit(): void {
  }
}
